import React from 'react';
import { observer } from 'mobx-react';

import { editingMode } from 'sdc-cms-writing';

import { EditingControls } from './editing';
import { ViewingControl } from './viewing';

export * from './boolean';

export var Controls = observer(function (props) {
  if (editingMode.isEditMode.get() && props.field.editable) return React.createElement(EditingControls, props);else return React.createElement(ViewingControl, props);
});